{
  "until": "{{duration}} menjelang {{prayer}}",
  "begin_focus": "Mula fokus",
  "add_task": "Tambah tugasan",
  "more_tasks": "+{{count}} lagi",
  "fajr_at": "Subuh pada {{time}}",
  "schedule_title": "Hari Ini",
  "plan_my_day": "Rancang hari saya",
  "planning": "Merancang…",
  "suggested": "Dicadangkan",
  "keep_plan": "Kekalkan rancangan",
  "undo_plan": "Buat asal",
  "plan_error": "Tidak dapat merancang sekarang. Cuba lagi.",
  "plan_empty": "Tiada apa untuk dirancang lagi — tambah tugasan dahulu.",
  "plan_settled": "Semuanya sudah di tempatnya.",
  "view_list": "Senarai",
  "view_switch_aria": "Tukar antara paparan senarai dan hari",
  "unassigned": "Belum dijadualkan",
  "assign_title": "Blok solat",
  "no_block": "Tiada blok",
  "assign_aria": "Tetapkan ke blok solat",
  "open_schedule_aria": "Buka jadual hari ini",
  "focus_session_label": "{{block}} · Fokus",
  "block_hero": "Kerja mendalam sehingga {{prayer}}",
  "moments_away": "{{prayer}} sebentar lagi",
  "block_clear": "Semua selesai — rehat sehingga {{prayer}}",
  "alhamdulillah": "Alhamdulillah",
  "exit_hint": "Tekan Esc untuk keluar perlahan",
  "exit_hint_touch": "Ketik ✕ untuk keluar perlahan",
  "mark_done_aria": "Tandakan tugasan selesai",
  "quick_add_placeholder": "Tambah ke blok ini…",
  "focus_task_aria": "Fokus pada tugasan ini"
}
